/** @jsxImportSource @emotion/react */

import { memo } from "react";

import { CheckboxProps, FormControlLabel, Checkbox as CheckboxComp } from "@material-ui/core";

interface Props extends CheckboxProps {
  label: string;
}

const Checkbox = ({ label, ...rest }: Props): JSX.Element => (
  <FormControlLabel control={<CheckboxComp color="primary" {...rest} />} label={label} />
);

export default memo(Checkbox);
